class DapCalendarPopover extends HTMLElement {
  #anchor = null;
  #onPointerDown = null;
  #onKeyDown = null;

  open(anchor = null) {
    if (this.hasAttribute("open")) return;
    this.#anchor = anchor;
    this.setAttribute("open", "");
    this.#position();
    this.#bindDismiss();
    this.dispatchEvent(new CustomEvent("dap:popover-open", { bubbles: true }));
  }

  close() {
    if (!this.hasAttribute("open")) return;
    this.removeAttribute("open");
    this.#unbindDismiss();
    this.#anchor = null;
    this.dispatchEvent(new CustomEvent("dap:popover-close", { bubbles: true }));
  }

  #position() {
    if (!this.#anchor || this.#isMobile()) {
      this.style.removeProperty("position");
      this.style.removeProperty("top");
      this.style.removeProperty("left");
      return;
    }
    const offsetParent = this.offsetParent || document.body;
    const parentRect = offsetParent.getBoundingClientRect();
    const anchorRect = this.#anchor.getBoundingClientRect();
    this.style.position = "absolute";
    this.style.top = `${anchorRect.bottom - parentRect.top}px`;
    this.style.left = `${anchorRect.left - parentRect.left}px`;
  }

  #isMobile() {
    return (
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 749px)").matches
    );
  }

  #bindDismiss() {
    this.#onPointerDown = (e) => {
      if (this.contains(e.target)) return;
      if (this.#anchor && this.#anchor.contains(e.target)) return;
      this.close();
    };
    this.#onKeyDown = (e) => {
      if (e.key === "Escape") this.close();
    };
    document.addEventListener("pointerdown", this.#onPointerDown, true);
    document.addEventListener("keydown", this.#onKeyDown);
  }

  #unbindDismiss() {
    if (this.#onPointerDown) {
      document.removeEventListener("pointerdown", this.#onPointerDown, true);
    }
    if (this.#onKeyDown) {
      document.removeEventListener("keydown", this.#onKeyDown);
    }
    this.#onPointerDown = null;
    this.#onKeyDown = null;
  }

  disconnectedCallback() {
    this.#unbindDismiss();
  }
}

if (typeof customElements !== "undefined") {
  if (!customElements.get("dap-calendar-popover")) {
    customElements.define("dap-calendar-popover", DapCalendarPopover);
  }
}

export { DapCalendarPopover };
